import React, { createContext, useCallback, useEffect, useMemo, useState } from 'react';
import { API_ENDPOINTS } from '../config/api';
import { DEFAULT_PRODUCT_TAGS, groupProductTags } from '../config/productTags';

export const ProductTagContext = createContext({
  productTags: DEFAULT_PRODUCT_TAGS,
  tagGroups: groupProductTags(DEFAULT_PRODUCT_TAGS),
  loading: true,
  refreshProductTags: async () => {}
});

export const ProductTagProvider = ({ children }) => {
  const [productTags, setProductTags] = useState(DEFAULT_PRODUCT_TAGS);
  const [loading, setLoading] = useState(true);

  const refreshProductTags = useCallback(async () => {
    try {
      const response = await fetch(API_ENDPOINTS.productTags.getAll());
      if (!response.ok) throw new Error('No se pudieron cargar las etiquetas');
      const data = await response.json();
      setProductTags(Array.isArray(data) ? data : DEFAULT_PRODUCT_TAGS);
    } catch (error) {
      console.error('Error al cargar etiquetas de productos:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refreshProductTags();
  }, [refreshProductTags]);

  const value = useMemo(() => ({
    productTags,
    tagGroups: groupProductTags(productTags),
    loading,
    refreshProductTags
  }), [productTags, loading, refreshProductTags]);

  return <ProductTagContext.Provider value={value}>{children}</ProductTagContext.Provider>;
};
